/* ============================================================
   LA FABRIQUE DES MINIS — fiche produit
   Toute la logique est pilotée par les attributs data-* posés
   sur la section #achat par lfdm-pdp-achat.liquid. Aucun prix,
   aucun identifiant de variante n'est écrit dans ce fichier :
   ils viennent des variantes Shopify.
     data-sizes    : « clé|min-max » par taille
     data-variants : « clé|S|prixCents|unités|idVariante|dispo|idPlan|prixPlanCents »
   ============================================================ */
(function () {
  'use strict';

  var PDP = document.getElementById('achat');
  if (!PDP) return;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var d = PDP.dataset;

  function eur(cents) {
    var v = (cents / 100);
    var s = (Math.round(v * 100) % 100 === 0) ? v.toFixed(0) : v.toFixed(2);
    return s.replace('.', ',') + ' €';
  }
  function toast(t) { if (window.LFDM && LFDM.toast) LFDM.toast(t); }
  function headerH() {
    var h = document.querySelector('.lfdm-header, header.lfdm-header, #lfdmHeader');
    return h ? h.offsetHeight : 0;
  }

  var P = {
    unit: d.unit || 'unité',
    prefix: d.unitPrefix || 'le',
    packWord: d.packWord || 'lot',
    optName: d.option1 || 'Taille',
    fmtSingle: d.fmtSingle || 'Sachet',
    fmtBundle: d.fmtBundle || 'Carton',
    subEvery: d.subEvery || '4 semaines',
    subPlanName: d.subPlan || 'Abonnement',
    lblOne: d.lblOne || 'Ajouter au panier',
    lblSub: d.lblSub || "M'abonner",
    noteOne: d.noteOne || '',
    noteSub: d.noteSub || ''
  };

  var SIZES = (d.sizes || '').split(',').filter(Boolean).map(function (x) {
    var p = x.split('|');
    var r = (p[1] || '').split('-');
    return { v: p[0].trim(), min: parseFloat(r[0]), max: parseFloat(r[1]), label: r[0] + ' à ' + r[1] + ' kg' };
  });

  var VARS = (d.variants || '').split(',').filter(Boolean).map(function (x) {
    var p = x.split('|');
    return {
      size: p[0].trim(), fmt: p[1].trim(),
      price: parseInt(p[2], 10) || 0,
      units: parseInt(p[3], 10) || 0,
      id: p[4] || '',
      av: p[5] === '1',
      planId: p[6] || '',
      planPrice: parseInt(p[7], 10) || 0
    };
  });

  var PACKS = {};
  (d.packs || '').split(',').filter(Boolean).forEach(function (x) {
    var p = x.split(':'); PACKS[p[0].trim()] = parseInt(p[1], 10) || 0;
  });

  var S = { size: null, fmt: 'S', mode: 'one', qty: 1 };

  function vr(size, fmt) {
    for (var i = 0; i < VARS.length; i++) if (VARS[i].size === size && VARS[i].fmt === fmt) return VARS[i];
    return null;
  }
  function plu(w, n) { return n > 1 ? w + 's' : w; }
  function nSach(size) {
    if (PACKS[size]) return PACKS[size];
    var s = vr(size, 'S'), c = vr(size, 'C');
    return (s && c && s.units) ? Math.round(c.units / s.units) : 1;
  }
  function sellable(size) { var s = vr(size, 'S'), c = vr(size, 'C'); return (s && s.av) || (c && c.av); }
  function minOf(fn) {
    var vals = SIZES.filter(function (s) { return sellable(s.v); }).map(function (s) { return fn(s.v); })
      .filter(function (n) { return n > 0; });
    return vals.length ? Math.min.apply(null, vals) : 0;
  }
  function hasSub() {
    for (var i = 0; i < VARS.length; i++) if (VARS[i].planId) return true;
    return false;
  }
  function subPriceFor(size) {
    var c = size ? vr(size, 'C') : null;
    if (c && c.planPrice) return c.planPrice;
    return minOf(function (k) { var b = vr(k, 'C'); return b ? b.planPrice : 0; });
  }

  /* ---------- tuiles de taille ---------- */
  var elSizes = $('#pSizes');
  if ($('#pOptLab')) $('#pOptLab').textContent = P.optName;
  elSizes.innerHTML = SIZES.map(function (s) {
    var ok = sellable(s.v);
    return '<button type="button" class="qa-sz" role="radio" aria-checked="false" data-val="' + s.v + '"' +
      (ok ? '' : ' disabled aria-disabled="true"') + '>' +
      '<b>' + s.v + '</b><small>' + s.min + '-' + s.max + ' kg</small></button>';
  }).join('');
  elSizes.addEventListener('click', function (e) {
    var b = e.target.closest('[data-val]');
    if (!b || b.hasAttribute('disabled')) return;
    S.size = b.dataset.val;
    if (S.mode === 'sub') S.fmt = 'C';
    render();
  });

  /* ---------- formats ---------- */
  function formats() {
    var list = [];
    var s = S.size ? vr(S.size, 'S') : null;
    var c = S.size ? vr(S.size, 'C') : null;
    var spread = [];
    SIZES.filter(function (x) { return sellable(x.v); }).forEach(function (x) {
      var n = nSach(x.v); if (spread.indexOf(n) < 0) spread.push(n);
    });
    spread.sort();

    if (VARS.some(function (v) { return v.fmt === 'S'; })) {
      list.push({
        id: 'S',
        label: s ? P.fmtSingle + ' de ' + s.units + ' ' + plu(P.unit, s.units) : P.fmtSingle,
        sub: '',
        price: s ? s.price : minOf(function (k) { var a = vr(k, 'S'); return a ? a.price : 0; }),
        disabled: S.mode === 'sub' || (s ? !s.av : false)
      });
    }
    if (VARS.some(function (v) { return v.fmt === 'C'; })) {
      list.push({
        id: 'C',
        label: P.fmtBundle,
        sub: (S.size && c)
          ? nSach(S.size) + ' ' + plu(P.packWord, nSach(S.size)) + ' · ' + c.units + ' ' + plu(P.unit, c.units)
          : spread.join(' ou ') + ' ' + plu(P.packWord, 2) + ' selon la ' + P.optName.toLowerCase(),
        price: S.mode === 'sub' ? subPriceFor(S.size)
          : (c ? c.price : minOf(function (k) { var a = vr(k, 'C'); return a ? a.price : 0; })),
        suffix: S.mode === 'sub' ? ' / ' + P.subEvery : '',
        disabled: c ? !c.av : false
      });
    }
    return list;
  }

  function renderFormats() {
    var list = formats();
    var pre = S.size ? '' : 'dès ';
    var hint = $('#pFmtHint');
    if (hint) hint.textContent = S.mode === 'sub' ? (d.subHint || '') : '';
    $('#pFormats').innerHTML = list.map(function (o) {
      return '<button type="button" class="qa-opt" role="radio" aria-checked="' + (o.id === S.fmt) + '" data-fmt="' + o.id + '"' +
        (o.disabled ? ' disabled style="opacity:.42;cursor:not-allowed"' : '') + '>' +
        '<span class="rad"></span><span class="txt"><b>' + o.label + '</b>' +
        (o.sub ? '<small>' + o.sub + '</small>' : '') + '</span>' +
        '<span class="pr">' + pre + eur(o.price) + (o.suffix || '') + '</span></button>';
    }).join('');
  }
  $('#pFormats').addEventListener('click', function (e) {
    var b = e.target.closest('[data-fmt]');
    if (!b || b.hasAttribute('disabled')) return;
    S.fmt = b.dataset.fmt; render();
  });

  /* ---------- mode d'achat ---------- */
  var tabs = $('#pTabs');
  if (tabs) {
    if (!hasSub()) { tabs.hidden = true; }
    else if ($('#pSubOff')) $('#pSubOff').textContent = eur(subPriceFor(null));
    $$('#pTabs button').forEach(function (b) {
      b.addEventListener('click', function () {
        S.mode = b.dataset.mode;
        $$('#pTabs button').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
        if (S.mode === 'sub') { S.fmt = 'C'; S.qty = 1; }
        render();
      });
    });
  }

  /* ---------- quantité ---------- */
  var qtyRow = $('#pQtyRow');
  qtyRow.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]');
    if (!b || b.hasAttribute('disabled')) return;
    S.qty = Math.max(1, Math.min(10, S.qty + (parseInt(b.dataset.q, 10))));
    render();
  });

  /* ---------- rendu ---------- */
  function current() {
    if (!S.size) return null;
    var v = vr(S.size, S.fmt);
    if (!v || !v.av) return null;
    return { v: v, price: S.mode === 'sub' ? (v.planPrice || v.price) : v.price, units: v.units };
  }

  function render() {
    renderFormats();
    $$('#pSizes .qa-sz').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.val === S.size)); });

    qtyRow.hidden = S.mode === 'sub';
    $('#pQty').textContent = S.qty;
    qtyRow.querySelector('[data-q="-1"]').disabled = S.qty <= 1;

    var cur = current();
    var add = $('#pAdd'), bar = $('#barAdd');
    var floor = minOf(function (k) { var a = vr(k, 'S'); return a ? a.price : 0; }) ||
                minOf(function (k) { var a = vr(k, 'C'); return a ? a.price : 0; });

    if (!cur) {
      $('#pTotal').textContent = 'dès ' + eur(floor);
      $('#pPer').textContent = '';
      $('#pSave').hidden = true;
      add.disabled = true;
      add.textContent = (d.lblChoose || 'Choisissez une ' + P.optName.toLowerCase());
      if (bar) {
        $('#barPrice').textContent = 'dès ' + eur(floor);
        $('#barVar').textContent = (d.lblChoose || 'Choisissez une ' + P.optName.toLowerCase());
        bar.disabled = false;
      }
      return;
    }

    var mult = S.mode === 'sub' ? 1 : S.qty;
    var total = cur.price * mult;
    var qtyUnits = cur.units * mult;

    $('#pTotal').textContent = eur(total) + (S.mode === 'sub' ? ' / ' + P.subEvery : '');
    $('#pPer').textContent = qtyUnits
      ? eur(total / qtyUnits) + ' ' + P.prefix + ' ' + P.unit + ' · ' + qtyUnits + ' ' + plu(P.unit, qtyUnits)
      : '';

    var pack = vr(S.size, 'S');
    var ref = pack ? pack.price * (S.fmt === 'C' ? nSach(S.size) : 1) : 0;
    var off = ref ? Math.round((1 - cur.price / ref) * 100) : 0;
    $('#pSave').hidden = off < 1;
    $('#pSave').textContent = '−' + off + ' % par ' + P.packWord;

    add.disabled = false;
    add.textContent = (S.mode === 'sub' ? P.lblSub : P.lblOne) + ' — ' + eur(total) + (S.mode === 'sub' ? ' / ' + P.subEvery : '');
    if (bar) {
      $('#barPrice').textContent = eur(total) + (S.mode === 'sub' ? ' / ' + P.subEvery : '');
      $('#barVar').textContent = P.optName + ' ' + S.size + ' · ' + (S.fmt === 'C' ? P.fmtBundle.toLowerCase() : P.packWord) +
        (S.mode === 'sub' ? ' · abonnement' : '');
      bar.disabled = false;
    }
    var note = $('#pNote');
    if (note) note.textContent = S.mode === 'sub' ? P.noteSub : P.noteOne;
  }

  /* ---------- ajout au panier ---------- */
  function addPdp() {
    var cur = current();
    if (!cur) { focusChoice(); return; }
    var item = { id: cur.v.id, quantity: S.mode === 'sub' ? 1 : S.qty };
    if (S.mode === 'sub' && cur.v.planId) item.selling_plan = cur.v.planId;
    var msg = (d.title || '') + ' · ' + P.optName.toLowerCase() + ' ' + S.size +
      (S.mode === 'sub' ? ' · abonnement' : '') + ' ajouté au panier';
    if (window.LFDM && LFDM.cartAdd) LFDM.cartAdd(item, msg);
    else window.location.href = '/cart/add?id=' + item.id + '&quantity=' + item.quantity;
  }
  $('#pAdd').addEventListener('click', addPdp);
  if ($('#barAdd')) $('#barAdd').addEventListener('click', addPdp);

  function focusChoice() {
    var t = elSizes;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - headerH() - 70, behavior: RM ? 'auto' : 'smooth' });
    $$('#pSizes .qa-sz').forEach(function (b) {
      b.classList.remove('flash'); void b.offsetWidth; b.classList.add('flash');
      setTimeout(function () { b.classList.remove('flash'); }, 1400);
    });
    toast("Choisissez d'abord une " + P.optName.toLowerCase());
  }

  /* ---------- galerie ---------- */
  var thumbs = $('.gal-thumbs', PDP);
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (!b) return;
      var i = b.dataset.go;
      $$('.gal-shot', PDP).forEach(function (s) { s.classList.toggle('on', s.dataset.shot === i); });
      $$('.gal-thumbs button', PDP).forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
    });
  }

  /* ---------- calculateur de taille ---------- */
  var range = document.getElementById('calcRange');
  if (range && SIZES.length) {
    var bounds = SIZES.filter(function (s) { return sellable(s.v); });
    if (!bounds.length) bounds = SIZES;
    range.min = bounds[0].min;
    range.max = bounds[bounds.length - 1].max;
    if (parseFloat(range.value) < range.min || parseFloat(range.value) > range.max) {
      range.value = bounds[Math.floor(bounds.length / 2)].min;
    }
    var scale = document.querySelector('.calc-scale');
    if (scale) {
      var sp = scale.children;
      if (sp[0]) sp[0].textContent = range.min + ' kg';
      if (sp[1]) sp[1].textContent = Math.round((+range.min + +range.max) / 2) + ' kg';
      if (sp[2]) sp[2].textContent = range.max + ' kg';
    }

    var sizeFor = function (kg) {
      var fit = bounds.filter(function (s) { return kg >= s.min && kg <= s.max; });
      if (fit.length) return fit[0];
      return kg < bounds[0].min ? bounds[0] : bounds[bounds.length - 1];
    };
    var calc = function () {
      var kg = parseFloat(range.value);
      range.style.setProperty('--p', ((kg - range.min) / (range.max - range.min) * 100) + '%');
      document.getElementById('calcKg').textContent = String(kg).replace('.', ',');
      var s = sizeFor(kg);
      document.getElementById('calcSize').textContent = s.v;
      document.getElementById('calcLab').textContent = P.optName + ' ' + s.v + ' · ' + s.label;
      var also = bounds.filter(function (x) { return x.v !== s.v && kg >= x.min && kg <= x.max; });
      document.getElementById('calcTxt').textContent = kg > bounds[bounds.length - 1].max
        ? 'Au-delà de nos tailles : la ' + s.v + ' reste la plus grande disponible.'
        : "C'est la taille de départ conseillée pour ce poids.";
      document.getElementById('calcAlt').textContent = also.length
        ? 'La ' + P.optName.toLowerCase() + ' ' + also.map(function (x) { return x.v; }).join(' ou ') +
          ' convient aussi — en cas de doute, gardez la plus petite.'
        : '';
      var pick = document.getElementById('calcPick');
      pick.dataset.size = s.v;
      pick.textContent = 'Choisir la ' + P.optName.toLowerCase() + ' ' + s.v;
    };
    range.addEventListener('input', calc);
    document.getElementById('calcPick').addEventListener('click', function () {
      S.size = document.getElementById('calcPick').dataset.size;
      render();
      window.scrollTo({ top: PDP.getBoundingClientRect().top + window.scrollY - headerH() - 16, behavior: RM ? 'auto' : 'smooth' });
      var tile = $('#pSizes [data-val="' + S.size + '"]');
      if (tile) { tile.classList.add('flash'); setTimeout(function () { tile.classList.remove('flash'); }, 1400); }
      toast(P.optName + ' ' + S.size + ' sélectionnée');
    });
    calc();
  }

  render();
})();
